/**
 * MentalityOverlay — Mentality Steps 3 + 4.
 *
 * Phase E4 split: this file is now a thin shell that owns the open/closed
 * state and delegates rendering to `mentality/MentalityFab` and
 * `mentality/MentalityPanel`. Data adapters live in `mentality/adapters`
 * and are re-exported here for tests that imported them from this path.
 */

import { useState } from 'react';
import DraggableMentalityFab from './mentality/MentalityFab';
import MentalityPanel from './mentality/MentalityPanel';
import './MentalityOverlay.css';

type Props = {
    /** Role the viewer holds — hides the overlay for users without a
     *  mentorship role. Passed by the Layout wrapper. */
    viewerRole: 'mentee' | 'mentor' | 'admin';
};

function MentalityOverlay({ viewerRole }: Props) {
    const [open, setOpen] = useState(false);

    if (!viewerRole) return null;

    return (
        <>
            {!open && <DraggableMentalityFab onOpen={() => setOpen(true)} />}
            {open && <MentalityPanel open={open} onClose={() => setOpen(false)} />}
        </>
    );
}

export default MentalityOverlay;

// Re-exports for stable import paths used by vitest suites + any
// external consumers of the data adapters. The canonical definitions
// live in `mentality/adapters.ts`.
export {
    riskToCard,
    insightToCard,
    profileToCards,
    resolveRuleRefs,
    type MatchCard,
} from './mentality/adapters';
